import { SWRConfiguration } from 'swr/dist/types';

import { User } from '../classes/User';
import { useUser } from '../hooks/useUser';

export interface RequireUserInterface {
  loadingComponent: JSX.Element;
  errorComponent: JSX.Element;
  children: React.ReactNode;
  // By default we show the app if the user is logged in.
  // Use this function to set further restrictions, e.g. userIsAuthorized={(user: User) => user.isP44Admin()}
  userIsAuthorized?: (user: User) => boolean;
  swrConfig?: SWRConfiguration;
}

/**
 * Requires a user to be logged in before rendering the children.
 */
export function RequireUser(props: RequireUserInterface) {
  // Calling this hook will redirect the user to the login page if they're not logged in
  const user = useUser({ swrConfig: props?.swrConfig });
  const userData = user.data;

  /**
   * `useUser` calls `useFetch`, which redirects to the login page when there is a 401.
   * This will continue showing the loading indicator when there is a 401 so that there
   * is not a flicker of the error page before the redirect actually occurs
   */
  if (user.isLoading || (user.error && user.error.statusCode === 401)) {
    return props.loadingComponent;
  } else if (user.error) {
    return props.errorComponent;
  } else if (
    userData &&
    props.userIsAuthorized &&
    !props.userIsAuthorized(userData)
  ) {
    return props.errorComponent;
  }

  return <>{props.children}</>;
}
